import { Button, Divider, Group, Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadMail } from 'modules/Mails/hooks';
import { useState } from 'react';
import { useParams } from 'react-router';
import { sortBy } from 'remeda';
import { ThreadMessage } from './MailDetailThread/ThreadMessage';

export const MailDetailThread = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { thread } = useLoadMail(id);

  const orderedMails = sortBy(
    thread.mails.filter(mail => !mail.isDraft),
    mail => mail.date?.valueOf() ?? 0,
  );
  const focusedId = orderedMails.at(-1)?.id;

  const [expandedMailIds, setExpandedMailIds] = useState<Array<string>>(() =>
    focusedId ? [focusedId] : [],
  );

  const onExpandMail = (messageId: string) => {
    setExpandedMailIds(prev =>
      prev.includes(messageId) ? prev.filter(id => id !== messageId) : [...prev, messageId],
    );
  };

  const expandAllMails = () => setExpandedMailIds(orderedMails.map(mail => mail.id));

  return (
    <Stack gap="space3" px="space8" mt="space6">
      <Group gap="space3" mih={22} align="center">
        <Text size="xs" c="dimmed" fw={600} tt="uppercase">
          {orderedMails.length === 1
            ? t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.CONVERSATION_HEADER_ONE)
            : t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.CONVERSATION_HEADER_OTHER, {
                count: orderedMails.length,
              })}
        </Text>
        <Divider style={{ flex: 1 }} />
        {expandedMailIds.length < orderedMails.length && (
          <Button variant="subtle" size="compact-xs" onClick={expandAllMails}>
            {t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.EXPAND_ALL)}
          </Button>
        )}
      </Group>

      {orderedMails.map(mail => {
        const isOpen = expandedMailIds.includes(mail.id);
        return (
          <ThreadMessage
            key={mail.id}
            mail={mail}
            isOpen={isOpen}
            debtor={thread.debtor}
            onExpandMail={() => onExpandMail(mail.id)}
          />
        );
      })}
    </Stack>
  );
};
